import React from 'react'
import Services from './Services/Services'
import OurSpecialties from './OurSpecialties/OurSpecialties'

const Specialties = () => {
  return (
    <>
     <Services/>
     <OurSpecialties/>
    </>
  )
}

export default Specialties
